<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
      <!-- Componente de Menu -->
      <print-conditions-menu
        ref="conditionsMenu"
        :isMobile="isMobile"
        @formClosed="unloadComponent"
        @saveMenu="saveMenu"
        :showMenu="showMenu"
      >
      </print-conditions-menu>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
      <!-- Componente de Condiciones. -->
      <print-conditions-data
        ref="conditionsData"
        :isMobile="isMobile"
        @formClosed="unloadComponentData"
        @saveData="saveData"
        :showData="showData"
      >
      </print-conditions-data>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import PrintConditionsMenu from "./PrintConditionsMenu";
import PrintConditionsData from "./PrintConditionsData";
import ToastMixin from "../../mixins/ToastMixin";

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin],
  async beforeDestroy() {},
  components: { PrintConditionsMenu, PrintConditionsData },
  computed: {
    isFormReadOnly() {
      var ret = false;
      switch (this.formAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      formData: null,
      formAction: 0,
      showData: false,
      showMenu: true
    };
  },
  beforeMount() {},
  created() {},
  async mounted() {},
  methods: {
    async loadComponent() {
      if (this.formAction != FormActionEnum.ADD) {
        await this.$store.dispatch(
          "printConditions/getPrintCondition",
          this.formData.conditionId
        );
        //si es nuevo la lista no se setea
        this.formData.isNew = false;
      }

      var lim = this.$store.getters["printConditions/currentPrintCondition"];
      this.formData = JSON.parse(JSON.stringify(lim));

      this.$refs.conditionsMenu.setFormData(this.formData, this.formAction);
      //this.$refs.conditionsData.setFormData(this.formData, this.formAction);
      this.$refs.conditionsMenu.DialogOpen();
      await this.$refs.conditionsData.DialogOpen();
    },
    async unloadComponent() {
      this.formAction == FormActionEnum.LIST;
      this.$refs.conditionsMenu.DialogClose();
      this.$refs.conditionsData.clearData();
      this.showData = false;
      this.showMenu = true;
      this.$emit("formClosed");
    },
    async unloadComponentData() {
      this.formAction == FormActionEnum.LIST;
      this.showData = false;
      this.showMenu = true;
      this.$emit("formClosed2");
    },
    async saveMenu(args) {
      try {
        var data = args;
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para cargar!",
              2000
            );
            break;
          case FormActionEnum.EDIT:
            this.showToast(
              "Datos Cargados!",
              "Se ha cargado la informacion correctamente!",
              3000
            );
            this.$refs.conditionsData.setFormData(data, this.formAction);
            this.showData = true;
            this.showMenu = false;
            break;
          case FormActionEnum.ADD:
            var hierarchy = await this.$store.dispatch(
              "printConditions/getPrintConditionHierarchy",
              data
            );
            if (hierarchy != undefined && hierarchy != null) {
              data.packages = hierarchy.packages.map(function (row) {
                return {
                  conditionId: data.conditionId,
                  packageId: row.packageId,
                  queueId: row.queueId
                };
              });
              data.documents = hierarchy.documents.map(function (row) {
                return {
                  conditionId: data.conditionId,
                  packageId: row.packageId,
                  documentId: row.documentId,
                  protectionType: row.protectionType,
                  passwordValue: row.passwordValue
                };
              });
              data.formats = hierarchy.formats.map(function (row) {
                return {
                  conditionId: data.conditionId,
                  packageId: row.packageId,
                  documentId: row.documentId,
                  formatId: row.formatId
                };
              });
              data.integrations = hierarchy.integrations.map(function (row) {
                return {
                  conditionId: data.conditionId,
                  packageId: row.packageId,
                  integrationId: row.integrationId
                };
              });

              this.showToast(
                "Datos Cargados!",
                "Se ha encontrado una condicion superior y se ha cargado su información!",
                3000
              );
            } else {
              this.showToast(
                "Datos Cargados!",
                "Se ha cargado la informacion correctamente!",
                3000
              );
            }
            console.log(data);

            this.$refs.conditionsData.setFormData(data, this.formAction);
            await this.$refs.conditionsData.setValues();
            this.showData = true;
            this.showMenu = false;
            break;
        }
      } catch (error) {
        console.log(error);
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    // showLoading() {
    //   console.log("Llamando a showLoading PrintConditionsForm");
    //   console.log(this.$parent);
    //   this.$parent.showLoading();
    // },
    // hideLoading(timeout = 2000) {
    //   console.log("Llamando a hideLoading PrintConditionsForm");
    //   this.$parent.hideLoading(timeout);
    // },
    async saveData(data) {
      try {
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            data.isActive = true;
            await this.$store.dispatch(
              "printConditions/createPrintCondition",
              data
            );

            this.showToast("Confirmación", "Registro Creado!", 2000);
            break;
          case FormActionEnum.EDIT:
            await this.$store.dispatch(
              "printConditions/updatePrintCondition",
              data
            );
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            break;
        }
        this.$emit("onDataChange", data);
        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.unloadComponent();
        }, 500);
      } catch (error) {
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    setFormData(data, action) {
      this.formData = data;
      this.formAction = action;
    }
  },
  props: {
    // formAction: {
    //   type: Number,
    //   required: true,
    //   default: 0
    // },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    }
    // formData: {
    //   type: Object,
    //   required: true
    // }
  }
});
</script>

<style></style>
